<mat-card class="slidecontent">
  <div class="headcontent">
    <div class="pophead">
      <h3>Add {{modulename}}</h3>
      <mat-icon class="close" (click)="closeListing(close)">close</mat-icon>
    </div>
  </div>

  <div class="dialog_content">
    <form [formGroup]="myFormGroup">
      <ng-container *ngFor="let field of coreFieldList">
        <div *ngIf="field.fieldID==0 && field.data.length>1" class="fullw groupHolder" [ngSwitch]="field.fieldTypeName">
          <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{field.data[0].groupName}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div *ngFor="let grpField of field.data">

              <div *ngIf="grpField.fieldID>0" class="fullw" [ngSwitch]="grpField.fieldTypeName">
                <ng-container *ngSwitchCase="'Textbox'">
                  <ng-container *ngIf="grpField.fieldName == 'Name'">
                    <div class="usernameinfo picorname">
                      <div class="picname">
                        <div class="pic">
                          <img *ngIf="ImageUploadURL!=''" src="{{ ImageUploadURL }}" alt="" />
                          <div class="picuploader">
                            <input type="file" alt="" (change)="onSelectFile($event)" />
                            <mat-icon>camera_alt</mat-icon>
                          </div>
                        </div>
                        <div class="name">
                          <mat-form-field>
                            <input matInput [required]="grpField.isRequired" placeholder="{{ grpField.fieldName }}" [readonly]="grpField.rolePermission==1"
                              formControlName="{{ grpField.fieldName }}" />
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="grpField.fieldName != 'Name'">
                    <ng-container *ngIf="grpField.fieldNames.length > 0">
                      <div class="multipleBlock">
                        <div class="multype">
                          <div class="primaryEmail">
                          <mat-form-field class="mulDropdown" appearance="">
                            <mat-select (selectionChange)="clearPlaceholder($event)"
                              formControlName="{{ grpField.fieldName + 'option' }}"
                              placeholder="{{ grpField.fieldNames[0].fieldName }}">
                              <mat-option value="{{ names.fieldNameID }}" *ngFor="let names of grpField.fieldNames">
                                {{ names.fieldName }}</mat-option>
                            </mat-select>
                          </mat-form-field>
                          <ng-container *ngIf="grpField.fieldName == 'Email'">
                            <div class="setPrimaryactive" matTooltip="Set as primary email" matTooltipClass="tooltip" *ngIf=" grpField.isPrimary == true" (click)="MakePrimaryParent($event,grpField)"> Primary</div>
                            <div class="setPrimary" matTooltip="Set as primary email" matTooltipClass="tooltip" *ngIf=" grpField.isPrimary == false" (click)="MakePrimaryParent($event,grpField)"> Primary</div>
                          </ng-container>
                        </div>
                          <mat-form-field>
                            <input *ngIf="grpField.fieldName == 'Phone'" matInput [required]="grpField.isRequired" [readonly]="grpField.rolePermission==1"
                              placeholder="Add Phone" value=""  [(ngModel)]="grpField.fieldValue"
                              formControlName="{{ grpField.fieldName }}" 
                              />
                              
                            <input *ngIf="grpField.fieldName != 'Phone'" [required]="grpField.isRequired" [readonly]="grpField.rolePermission==1"
                              placeholder="{{ grpField.placeholder }}" matInput value=""
                              formControlName="{{ grpField.fieldName }}"  [(ngModel)]="grpField.fieldValue" />

                          </mat-form-field>
                          <div class="inOline" *ngIf="grpField.fieldName == 'Address'">

                            <div class="divide">
                              <mat-form-field class="example-full-width">
                                <input type="text"  placeholder="City" [(ngModel)]="cityValue" aria-label="Number" matInput [readonly]="grpField.rolePermission==1"
                                (input)="searchCity($event.target.value)" formControlName="City" [matAutocomplete]="auto">
                              <mat-autocomplete #auto="matAutocomplete">
                                <mat-option *ngFor="let option of cityOption" [value]="option">
                                  {{option}}
                                </mat-option>
                              </mat-autocomplete>
  
                            </mat-form-field>
                            </div>

                            <div class="divide">
                              <mat-form-field >
                                <mat-label>State</mat-label>
                                <mat-select formControlName="State"  placeholder="State"  [(ngModel)]="stateValue" [disabled]="grpField.rolePermission==1">
                                  <mat-option>None</mat-option>
                                  <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                </mat-select>
                              </mat-form-field>

                              
                            </div>

                            <div class="divide">
                              <mat-form-field class="example-full-width">
                                <input type="text" matInput placeholder="Zip Code" [(ngModel)]="zipValue" aria-label="Number" [readonly]="grpField.rolePermission==1"
                              (input)="searchZip($event.target.value)" formControlName="ZipCode"
                              [matAutocomplete]="ZipCode">
                            <mat-autocomplete #ZipCode="matAutocomplete">
                              <mat-option *ngFor="let option of zipOption" [value]="option">
                                {{option}}
                              </mat-option>
                            </mat-autocomplete>
                              </mat-form-field>

                            </div>                           
                          </div>

                          <span class="addmore" (click)="addMore(grpField.fieldName)"
                            *ngIf="grpField.fieldNames.length > 0">
                            Add more</span>
                        </div>
                      </div>

                      <div class="multipleBlock" *ngIf="grpField.fieldName == 'Email'">

                        <div class="multype" *ngFor="let element of dynamicArray; let i = index">
                          <div class="primaryEmail">
                          <mat-form-field class="mulDropdown" appearance="">
                            <mat-select (selectionChange)="clearPlaceholder($event)" formControlName="{{
                                element.fieldName + (i + 1) + 'option'}}" placeholder="{{ grpField.fieldNames[0].fieldName }}">
                              <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                  let names of element.fieldNames;
                                  trackby: fieldNameID
                                ">{{ names.fieldName }}</mat-option>
                            </mat-select>
                          </mat-form-field>
                          <div class="setPrimary" matTooltip="Set as primary email" matTooltipClass="tooltip" *ngIf=" element.isPrimary == false" (click)="MakePrimaryChild($event,element)"> Primary</div>
                          <div class="setPrimaryactive" matTooltip="Set as primary email" matTooltipClass="tooltip" *ngIf=" element.isPrimary == true"> Primary</div>            
                        </div>

                          <mat-form-field class="extraInput">
                            <mat-label>Add Email</mat-label>

                            <input *ngIf="aiDetails.length == 0" matInput formControlName="{{ element.fieldName + (i + 1) }}" [readonly]="grpField.rolePermission==1" placeholder="Add Email">

                            <input *ngIf="aiDetails.length > 0" matInput formControlName="{{ element.fieldName + (i + 1) }}" [readonly]="grpField.rolePermission==1" placeholder="Add Email"
                             [(ngModel)]="grpField.fieldValue"> 

                          </mat-form-field>

                          <span class="addmore" (click)="addMore(grpField.fieldName)"
                            *ngIf="grpField.fieldNames.length > 0">
                            Add more</span>
                        </div>
                      </div>

                      <div class="multipleBlock" *ngIf="grpField.fieldName == 'Phone'">
                        <div class="multype" *ngFor="let element of dynamicArrayPhone; let i = index">
                          <mat-form-field class="mulDropdown" appearance="">
                            <mat-select (selectionChange)="clearPlaceholder($event)" formControlName="{{
                                element.fieldName + (i + 1) + 'option'
                              }}" placeholder="{{ grpField.fieldNames[0].fieldName }}">
                              <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                  let names of element.fieldNames;
                                  trackby: fieldNameID
                                ">{{ names.fieldName }}</mat-option>
                            </mat-select>
                          </mat-form-field>


                          <mat-form-field class="example-full-width">
                            <mat-label>Add Phone</mat-label>
                            <input matInput  matInput formControlName="{{ element.fieldName + (i + 1) }}" [readonly]="grpField.rolePermission==1"
                              placeholder="Add Phone"  [(ngModel)]="grpField.fieldValue">
                              <!-- mask="(000) 000-0000" -->
                          </mat-form-field>

                          <span class="addmore" (click)="addMore(grpField.fieldName)"
                            *ngIf="grpField.fieldNames.length > 0">
                            Add more</span>
                        </div>
                      </div>

                      <div class="multipleBlock" *ngIf="grpField.fieldName == 'Address'">
                        
                        <div class="multype" *ngFor="let element of dynamicArrayAddress; let i = index">
                          <mat-form-field class="mulDropdown" appearance="">
                            <mat-select (selectionChange)="clearPlaceholder($event)" formControlName="{{
                                element.fieldName + (i + 1) + 'option'
                              }}" placeholder="{{ grpField.fieldNames[0].fieldName }}">
                              <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                  let names of element.fieldNames;
                                  trackby: fieldNameID
                                ">{{ names.fieldName }}</mat-option>
                            </mat-select>
                          </mat-form-field>


                          <mat-form-field class="example-full-width">
                            <mat-label>Street</mat-label>
                            <input  matInput placeholder="Street" value=""  [(ngModel)]="grpField.fieldValue"
                            formControlName="{{ element.fieldName + (i + 1) }}" [readonly]="grpField.rolePermission==1" />
                          </mat-form-field>

                         
                          <div class="inOline">

                            <div class="divide">



                              <mat-form-field class="example-full-width">
                                <input type="text" matInput
                                placeholder="City" aria-label="Number" 
                                (input)="searchCity($event.target.value)" formControlName="City{{(i + 1) }}"
                                [matAutocomplete]="auto" [readonly]="grpField.rolePermission==1">
                                <mat-autocomplete #auto="matAutocomplete">
                                  <mat-option *ngFor="let option of cityOption" [value]="option">
                                    {{option}}
                                  </mat-option>
                                </mat-autocomplete>
                              </mat-form-field>

                              <!-- <input type="text" placeholder="City" aria-label="Number" 
                                (input)="searchCity($event.target.value)" formControlName="City{{(i + 1) }}"
                                [matAutocomplete]="auto">
                                <mat-autocomplete #auto="matAutocomplete">
                                  <mat-option *ngFor="let option of cityOption" [value]="option">
                                    {{option}}
                                  </mat-option>
                                </mat-autocomplete> -->

                            </div>

                            <div class="divide">
                             
                              <mat-form-field appearance="">
                                <mat-label>State</mat-label>
                                <mat-select formControlName="State{{ (i + 1) }}"  placeholder="State" [disabled]="grpField.rolePermission==1">
                                  <mat-option>None</mat-option>
                                  <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                </mat-select>
                              </mat-form-field>


                             
                            </div>

                            <div class="divide">

                              <mat-form-field class="example-full-width">
                                <input matInput
                                type="text" placeholder="Zip Code" aria-label="Number" 
                                (input)="searchZip($event.target.value)" formControlName="ZipCode{{ (i + 1) }}"
                                [matAutocomplete]="ZipCode" [readonly]="grpField.rolePermission==1">
                                <mat-autocomplete #ZipCode="matAutocomplete">
                                  <mat-option *ngFor="let option of zipOption" [value]="option">
                                    {{option}}
                                  </mat-option>
                                </mat-autocomplete>
                              </mat-form-field>


                              <!-- <input type="text" placeholder="Zip Code" aria-label="Number" 
                                (input)="searchZip($event.target.value)" formControlName="ZipCode{{ (i + 1) }}"
                                [matAutocomplete]="ZipCode">
                                <mat-autocomplete #ZipCode="matAutocomplete">
                                  <mat-option *ngFor="let option of zipOption" [value]="option">
                                    {{option}}
                                  </mat-option>
                                </mat-autocomplete> -->
                            </div>

                            

                          </div>

                          
                        </div>
                        <span class="addmore" (click)="addMore(grpField.fieldName)"
                            *ngIf="grpField.fieldNames.length > 0">
                            Add more</span>
                      </div>

                      <div class="multipleBlock" *ngIf="grpField.fieldName == 'WebSite'">
                        <div class="multype" *ngFor="let element of dynamicArrayWebsite; let i = index">
                          <mat-form-field class="mulDropdown" appearance="">
                            <mat-select (selectionChange)="clearPlaceholder($event)" formControlName="{{
                                element.fieldName + (i + 1) + 'option'
                              }}">
                              <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                  let names of element.fieldNames;
                                  trackby: fieldNameID
                                ">{{ names.fieldName }}</mat-option>
                            </mat-select>
                          </mat-form-field>

                          <mat-form-field class="example-full-width">
                            <mat-label>WebSite</mat-label>
                            <input matInput placeholder="WebSite" value=""
                            formControlName="{{ element.fieldName + (i + 1) }}" [readonly]="grpField.rolePermission==1" />
                          </mat-form-field>


                         

                         
                        </div>
                        <span class="addmore" (click)="addMore(grpField.fieldName)"
                        *ngIf="grpField.fieldNames.length > 0">
                        Add more</span>
                      </div>
                    </ng-container>

                    <mat-form-field *ngIf="grpField.fieldNames.length === 0">
                      <mat-label>{{ grpField.fieldName }}</mat-label>
                      <input matInput [required]="grpField.isRequired" placeholder="Add {{ grpField.fieldName }}" [readonly]="grpField.rolePermission==1"
                        formControlName="{{ grpField.fieldName }}"  [(ngModel)]="grpField.fieldValue"/>
                    </mat-form-field>
                  </ng-container>
                </ng-container>

                <ng-container *ngSwitchCase="'Textarea'">
                  <mat-form-field>
                    <textarea matInput [required]="grpField.isRequired" placeholder="{{ grpField.fieldName }}" [readonly]="grpField.rolePermission==1"
                      formControlName="{{ grpField.fieldName }}" [(ngModel)]="grpField.fieldValue">
                    </textarea>
                  </mat-form-field>
                </ng-container>

                <ng-container *ngSwitchCase="'Number'">
                  <mat-form-field>
                    <input matInput [required]="grpField.isRequired" (keypress)="numberOnly($event)" [readonly]="grpField.rolePermission==1"
                      placeholder="{{ grpField.fieldName }}" formControlName="{{ grpField.fieldName }}" 
                      [(ngModel)]="grpField.fieldValue"/>
                  </mat-form-field>
                </ng-container>

                <ng-container *ngSwitchCase="'Currency'">
                  <mat-form-field>
                    <input matInput [required]="grpField.isRequired" [readonly]="grpField.rolePermission==1"
                      placeholder="{{ grpField.fieldName }}" formControlName="{{ grpField.fieldName }}" 
                      [(ngModel)]="grpField.fieldValue" />
                  </mat-form-field>
                </ng-container>

                <ng-container *ngSwitchCase="'Address'">
                  <mat-form-field>
                    <input matInput [required]="grpField.isRequired" [readonly]="grpField.rolePermission==1"
                      placeholder="{{ grpField.fieldName }}" formControlName="{{ grpField.fieldName }}" 
                      [(ngModel)]="grpField.fieldValue"/>
                  </mat-form-field>
                </ng-container>

                <ng-container *ngSwitchCase="'Image'">

                  <mat-label>{{ grpField.fieldName }}</mat-label>
                  <div class="pic">
                    <input type="file" placeholder="{{ grpField.fieldName }}" formControlName="{{ grpField.fieldName }}" [readonly]="grpField.rolePermission==1"
                      (change)="onSelectFile($event)" />
                    <span class="ico">
                      <mat-icon>add_a_photo</mat-icon>
                    </span>
                  </div>

                </ng-container>

                <ng-container *ngSwitchCase="'Date'">
                  <mat-form-field>
                    <mat-label>{{ grpField.fieldName }}</mat-label>
                    <input matInput [required]="grpField.isRequired" [matDatepicker]="basicDatepicker" [readonly]="grpField.rolePermission==1"
                      placeholder="{{ grpField.fieldName }}" formControlName="{{ grpField.fieldName }}"
                      [(ngModel)]="grpField.fieldValue" />
                    <mat-datepicker-toggle matSuffix [for]="basicDatepicker"></mat-datepicker-toggle>
                    <mat-datepicker #basicDatepicker></mat-datepicker>
                  </mat-form-field>
                </ng-container>

                <ng-container *ngSwitchCase="'URL'">
                  <mat-form-field>
                    <mat-label>{{ grpField.fieldName }}</mat-label>
                    <input matInput [required]="grpField.isRequired" placeholder="{{ grpField.fieldName }}" [readonly]="grpField.rolePermission==1"
                      formControlName="{{ grpField.fieldName }}" />
                  </mat-form-field>
                </ng-container>

                <ng-container *ngSwitchCase="'Dropdown'">
                  <mat-form-field>
                    <mat-label>{{ grpField.fieldName }}</mat-label>
                    <mat-select [required]="grpField.isRequired" formControlName="{{ grpField.fieldName }}" [disabled]="grpField.rolePermission==1"
                     [ngModel]="getddlSelectedVal(grpField.fieldName,grpField.fieldValue)">
                      <mat-option *ngFor="let drp of getdropdownlist(grpField.fieldName)" [value]="drp">
                        {{ drp }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ng-container>

                <ng-container *ngSwitchCase="'MultiSelect'">
                  <mat-form-field class="example-chip-list" *ngIf="grpField.fieldName == 'Tags'">
                    <mat-label>{{ grpField.fieldName }}</mat-label>
                    <mat-chip-list [required]='grpField.isRequired' #chipList aria-label="Tag selection">
                      <mat-chip *ngFor="let tag of tags" [selectable]="selectable" [removable]="removable"
                        (removed)="remove(tag)">
                        {{tag}}
                        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                      </mat-chip>
                      <input placeholder="Add Tags" #fruitInput [formControl]="fruitCtrl" [matAutocomplete]="auto"
                        [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        (matChipInputTokenEnd)="add($event)">
                    </mat-chip-list>
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                      <mat-option *ngFor="let tag of filteredFruits | async" [value]="tag">
                        {{tag}}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
    
                  <mat-form-field *ngIf="grpField.fieldName != 'Tags'">
                    <mat-label>{{ grpField.fieldName }}</mat-label>
                    <mat-select [disabled] = "grpField.rolePermission==1" [required]='grpField.isRequired' multiple
                      formControlName="{{ grpField.fieldName }}">
                      <mat-option *ngFor="
                          let muldrp of getMuldropdownlist(grpField.fieldName)
                        " [value]="muldrp">
                        {{ muldrp }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  
                </ng-container>
                
                <!-- <ng-container *ngSwitchCase="'MultiSelect'">
                  <mat-form-field>
                    <mat-label>{{ grpField.fieldName }}</mat-label>
                    <mat-select [required]="grpField.isRequired" multiple formControlName="{{ grpField.fieldName }}" [disabled]="grpField.rolePermission==1">
                      <mat-option *ngFor="let muldrp of getMuldropdownlist(grpField.fieldName)" [value]="muldrp">
                        {{ muldrp }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ng-container> -->

                <!-- <ng-container *ngSwitchCase="'MultiSelect' && grpField.fieldName =='Tags'">
                  <mat-form-field class="example-chip-list">
                    <mat-label>{{ grpField.fieldName }}</mat-label>
                    <mat-chip-list [required]="grpField.isRequired" #chipList aria-label="Tag selection">
                      <mat-chip *ngFor="let tag of tags" [selectable]="selectable" [removable]="removable"
                        (removed)="remove(tag)">
                        {{tag}}
                        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                      </mat-chip>
                      <input [readonly]="grpField.rolePermission==1" placeholder="Add Tags" #fruitInput [formControl]="fruitCtrl" [matAutocomplete]="auto"
                        [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        (matChipInputTokenEnd)="add($event)">
                    </mat-chip-list>
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                      <mat-option *ngFor="let tag of filteredFruits | async" [value]="tag">
                        {{tag}}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </ng-container> -->
                

                <ng-container *ngSwitchCase="'Checkbox'">
                  <mat-label>{{ grpField.fieldName }}</mat-label>
                  <ul class="check">
                    <li *ngFor="let chk of getCheckBoxlist(grpField.fieldName)">
                      <mat-checkbox [disabled]="grpField.rolePermission==1" color="primary" (change)="OnChange($event, chk, grpField.fieldID)">
                        {{ chk }}
                      </mat-checkbox>
                    </li>
                  </ul>
                </ng-container>
              </div>
            </div>
          </mat-expansion-panel>
        </div>
        <div class="fullw" [ngSwitch]="field.fieldTypeName">
          <ng-container *ngSwitchCase="'Textbox'">
            <ng-container *ngIf="field.fieldName == 'Name'">
              <div class="usernameinfo picorname">
                <div class="picname">
                  <div class="pic">
                    <img *ngIf="ImageUploadURL!=''" src="{{ ImageUploadURL }}" alt="" />
                    <div class="picuploader">
                      <input type="file" alt="" (change)="onSelectFile($event)" />
                      <mat-icon>camera_alt</mat-icon>
                    </div>
                  </div>
                  <div class="name">

                    <mat-form-field>
                      <mat-label>{{ field.fieldName }}</mat-label>
                      <input matInput [required]="field.isRequired" placeholder="{{ field.placeholder }}" [readonly] = "field.rolePermission==1"
                      [(ngModel)]="name"  formControlName="{{ field.fieldName }}" (input)="CheckName($event.target.value)" />
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="field.fieldName != 'Name'">
              <ng-container *ngIf="field.fieldNames.length > 0">
                <div class="multipleBlock">
                  <div class="multype">
                    <div class="primaryEmail">
                    <mat-form-field class="mulDropdown" appearance="">
                      <mat-select (selectionChange)="clearPlaceholder($event)"
                        formControlName="{{ field.fieldName + 'option' }}"
                        placeholder="{{ field.fieldNames[0].fieldName }}">
                        <mat-option value="{{ names.fieldNameID }}" *ngFor="let names of field.fieldNames">
                          {{ names.fieldName }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <ng-container *ngIf="field.fieldName == 'Email'">
                      <div class="setPrimaryactive" matTooltip="Set as primary email" matTooltipClass="tooltip" *ngIf=" field.isPrimary == true" (click)="MakePrimaryParent($event,field)"> Primary</div>
                      <div class="setPrimary" matTooltip="Set as primary email" matTooltipClass="tooltip" *ngIf=" field.isPrimary == false" (click)="MakePrimaryParent($event,field)"> Primary</div>
                    </ng-container>
                  </div>
                    <mat-form-field>
                      <mat-label>{{ field.fieldName }}</mat-label>
                      <input matInput *ngIf="field.fieldName == 'Phone'" [required]='field.isRequired' [readonly] = "field.rolePermission==1"
                        placeholder="Add Phone" value="" formControlName="{{ field.fieldName }}"
                         [(ngModel)]="field.fieldValue" />
                      <input matInput *ngIf="field.fieldName  != 'Phone'" [required]='field.isRequired' [readonly] = "field.rolePermission==1"
                        placeholder="{{ field.placeholder }}" value="" formControlName="{{ field.fieldName }}"  [(ngModel)]="field.fieldValue" />
                    </mat-form-field>

                    <div class="AddressHolder" *ngIf="field.fieldName == 'Address'">
                      <div class="inOline">

                        <div class="divide">
                          <mat-form-field class="example-full-width">
                          <input matInput type="text" [(ngModel)]="cityValue" placeholder="City" aria-label="Number" [readonly] = "field.rolePermission==1"
                             (input)="searchCity($event.target.value)" formControlName="City"
                            [matAutocomplete]="auto">
                            <mat-autocomplete #auto="matAutocomplete">
                              <mat-option *ngFor="let option of cityOption" [value]="option">
                                {{option}}
                              </mat-option>
                            </mat-autocomplete>
                          </mat-form-field>
                        </div>

                        <div class="divide">
                          
                          <mat-form-field >
                            <mat-label>State</mat-label>
                            <mat-select [(ngModel)]="stateValue" formControlName="State" placeholder="State" [disabled]="field.rolePermission==1">
                              <mat-option>None</mat-option>
                              <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                          
                        </div>

                        <div class="divide">
                          <mat-form-field class="example-full-width">
                          <input type="text" [(ngModel)]="zipValue" placeholder="Zip Code" aria-label="Number" [readonly] = "field.rolePermission==1"
                          matInput (input)="searchZip($event.target.value)" formControlName="ZipCode"
                            [matAutocomplete]="ZipCode">
                          <mat-autocomplete #ZipCode="matAutocomplete">
                            <mat-option *ngFor="let option of zipOption" [value]="option">
                              {{option}}
                            </mat-option>
                          </mat-autocomplete>
                          </mat-form-field>
                        </div>



                      </div>

                    </div>


                    
                  </div>
                  <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                    Add more</span>
                </div>

                <div class="multipleBlock" *ngIf="field.fieldName == 'Email'">                 

                  <div class="multype" *ngFor="let element of dynamicArray; let i = index">
                   
                    <div class="primaryEmail">

                    <mat-form-field class="mulDropdown" appearance="">
                      <mat-select (selectionChange)="clearPlaceholder($event)"
                       formControlName="{{element.fieldName}}"
                       placeholder="{{ field.fieldNames[0].fieldName }}">
                        <mat-option value="{{ names.fieldNameID }}" *ngFor="
                              let names of element.fieldNames;
                              trackby: fieldNameID
                            ">{{ names.fieldName }}</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <div class="setPrimary" matTooltip="Set as primary email" matTooltipClass="tooltip" *ngIf=" element.isPrimary == false" (click)="MakePrimaryChild($event,element)"> Primary</div>
                    <div class="setPrimaryactive" matTooltip="Set as primary email" matTooltipClass="tooltip" *ngIf=" element.isPrimary == true"> Primary</div>            
                  </div>
                  <mat-form-field class="extraInput">
                    <mat-label>Add Email</mat-label>
                    <input *ngIf="aiDetails.length == 0" matInput formControlName="{{ element.fieldName + (i + 1) }}" placeholder="Add Email" [readonly] = "field.rolePermission==1" >
                    <input *ngIf="aiDetails.length > 0" matInput formControlName="{{ element.fieldName + (i + 1) }}" placeholder="Add Email" [readonly] = "field.rolePermission==1" [(ngModel)]="field.fieldValue">
                  </mat-form-field>
                  </div>
                  <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                    Add more</span>
                </div>

                <div class="multipleBlock" *ngIf="field.fieldName == 'Phone'">
                  <div class="multype" *ngFor="let element of dynamicArrayPhone; let i = index">
                    <mat-form-field class="mulDropdown" appearance="">
                      <mat-select (selectionChange)="clearPlaceholder($event)" formControlName="{{
                            element.fieldName + (i + 1) + 'option'
                          }}" placeholder="{{ field.fieldNames[0].fieldName }}">
                        <mat-option value="{{ names.fieldNameID }}" *ngFor="
                              let names of element.fieldNames;
                              trackby: fieldNameID
                            ">{{ names.fieldName }}</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field class="example-full-width">
                      <mat-label>Add Phone</mat-label>
                      <input matInput  formControlName="{{ element.fieldName + (i + 1) }}"
                        placeholder="Add Phone" [readonly] = "field.rolePermission==1"  [(ngModel)]="field.fieldValue">
                    </mat-form-field>

                    <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                      Add more</span>
                  </div>
                </div>

                <div class="multipleBlock" *ngIf="field.fieldName == 'Address'">
                  <div class="multype" *ngFor="let element of dynamicArrayAddress; let i = index">
                    <mat-form-field class="mulDropdown" appearance="">
                      <mat-select (selectionChange)="clearPlaceholder($event)" formControlName="{{
                            element.fieldName + (i + 1) + 'option'
                          }}" placeholder="{{ field.fieldNames[0].fieldName }}">
                        <mat-option value="{{ names.fieldNameID }}" *ngFor="
                              let names of element.fieldNames;
                              trackby: fieldNameID
                            ">{{ names.fieldName }}</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field class="example-full-width">
                      <mat-label>Street</mat-label>
                      <input matInput placeholder="Street" value=""
                      formControlName="{{ element.fieldName + (i + 1) }}" [readonly] = "field.rolePermission==1"  [(ngModel)]="field.fieldValue"/>
                    </mat-form-field>

                    

                    <div class="inOline">

                      <div class="divide">
                        <mat-form-field class="example-full-width">
                        <input placeholder="City" aria-label="Number" value="" matInput [readonly] = "field.rolePermission==1"
                          (input)="searchCity($event.target.value)" formControlName="City{{(i + 1) }}"
                          [matAutocomplete]="auto">
                          <mat-autocomplete #auto="matAutocomplete">
                            <mat-option *ngFor="let option of cityOption" [value]="option">
                              {{option}}
                            </mat-option>
                          </mat-autocomplete>
                        </mat-form-field>
                      </div>

                      <div class="divide">
                        
                        <mat-form-field >
                          <mat-label>State</mat-label>
                        <mat-select formControlName="State{{ (i + 1) }}"  placeholder="State" [disabled]="field.rolePermission==1">
                          <mat-option>None</mat-option>
                          <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                        </mat-select>
                        </mat-form-field>
                      </div>

                      <div class="divide">
                        <mat-form-field class="example-full-width">
                        <input type="text" placeholder="Zip Code" aria-label="Number" matInput [readonly] = "field.rolePermission==1"
                          (input)="searchZip($event.target.value)" formControlName="ZipCode{{ (i + 1) }}"
                          [matAutocomplete]="ZipCode">
                        <mat-autocomplete #ZipCode="matAutocomplete">
                          <mat-option *ngFor="let option of zipOption" [value]="option">
                            {{option}}
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>
                      </div>





                    </div>
                    <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                      Add more</span>
                  </div>
                </div>

                <div class="multipleBlock" *ngIf="field.fieldName == 'WebSite'">
                  <div class="multype" *ngFor="let element of dynamicArrayWebsite; let i = index">
                    <mat-form-field class="mulDropdown" appearance="">
                      <mat-select (selectionChange)="clearPlaceholder($event)" formControlName="{{
                            element.fieldName + (i + 1) + 'option'
                          }}">
                        <mat-option value="{{ names.fieldNameID }}" *ngFor="
                              let names of element.fieldNames;
                              trackby: fieldNameID
                            ">{{ names.fieldName }}</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="">
                      <mat-label>WebSite</mat-label>
                      <input  matInput placeholder="" value=""
                      formControlName="{{ element.fieldName + (i + 1) }}" [readonly] = "field.rolePermission==1"  [(ngModel)]="field.fieldValue" />
                      </mat-form-field>
                    
                    <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                      Add more</span>
                  </div>
                </div>
              </ng-container>

              <mat-form-field *ngIf="field.fieldNames.length === 0">
                <mat-label>{{ field.fieldName }}</mat-label>
                <input matInput placeholder=" {{ field.placeholder }}"  [required]="field.isRequired" [readonly] = "field.rolePermission==1"
                  formControlName="{{ field.fieldName }}" [(ngModel)]="field.fieldValue" />
              </mat-form-field>
            </ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="'Textarea'">
            <mat-form-field>
              <mat-label>{{ field.fieldName }}</mat-label>
              <textarea matInput placeholder="{{ field.placeholder }}" [required]="field.isRequired" [readonly] = "field.rolePermission==1"
                formControlName="{{ field.fieldName }}" [(ngModel)]="field.fieldValue">
              </textarea>
            </mat-form-field>
          </ng-container>

          <ng-container *ngSwitchCase="'Number'">
            <mat-form-field>
              <mat-label>{{ field.fieldName }}</mat-label>
              <input matInput (keypress)="numberOnly($event)" [required]="field.isRequired" [readonly] = "field.rolePermission==1"
                placeholder="{{ field.placeholder }}" formControlName="{{ field.fieldName }}" 
                [(ngModel)]="field.fieldValue"/>
            </mat-form-field>
          </ng-container>

          <ng-container *ngSwitchCase="'Currency'">
            <mat-form-field>
              <mat-label>{{ field.fieldName }}</mat-label>
              <input matInput [required]="field.isRequired" [readonly] = "field.rolePermission==1"
                placeholder="{{ field.placeholder }}" formControlName="{{ field.fieldName }}" 
                [(ngModel)]="field.fieldValue"/>
            </mat-form-field>
          </ng-container>

          <ng-container *ngSwitchCase="'Address'">
            <mat-form-field>
              <mat-label>{{ field.fieldName }}</mat-label>
              <input matInput [required]="field.isRequired" [readonly] = "field.rolePermission==1"
                placeholder="{{ field.placeholder }}" formControlName="{{ field.fieldName }}" 
                [(ngModel)]="field.fieldValue"/>
            </mat-form-field>
          </ng-container>

          <ng-container *ngSwitchCase="'Image'">
            <mat-label>{{ field.fieldName }}</mat-label>
            <div class="pic">
              <input type="file" placeholder="{{ field.fieldName }}" formControlName="{{ field.fieldName }}" [readonly] = "field.rolePermission==1"
                (change)="onSelectFile($event)" />
              <span class="ico">
                <mat-icon>add_a_photo</mat-icon>
              </span>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'Date'">
            <mat-form-field>
              <mat-label>{{ field.fieldName }}</mat-label>
              <input matInput [matDatepicker]="basicDatepicker" [required]="field.isRequired" [readonly] = "field.rolePermission==1"
                placeholder="{{ field.placeholder }}" formControlName="{{ field.fieldName }}" 
                [(ngModel)]="field.fieldValue"/>
              <mat-datepicker-toggle matSuffix [for]="basicDatepicker"></mat-datepicker-toggle>
              <mat-datepicker #basicDatepicker></mat-datepicker>
            </mat-form-field>
          </ng-container>

          <ng-container *ngSwitchCase="'URL'">
            <mat-form-field>
              <mat-label>{{ field.fieldName }}</mat-label>
              <input matInput placeholder="{{ field.placeholder }}" [required]="field.isRequired" [readonly] = "field.rolePermission==1"
                formControlName="{{ field.fieldName }}" />
            </mat-form-field>
          </ng-container>

          <ng-container *ngSwitchCase="'Dropdown'">
            <mat-form-field *ngIf="field.fieldName == 'Type'">
              <mat-label>{{ field.fieldName }}</mat-label>
              <mat-select [required]="field.isRequired" formControlName="{{ field.fieldName }}"
                (selectionChange)="getSubFolderFields($event,field.fieldName)">
                <mat-option *ngFor="let typelist of AllTypeList" [value]="typelist.subFolderID">
                  {{typelist.folderName}}
                </mat-option>
              </mat-select>

            </mat-form-field>

           <mat-form-field *ngIf="field.fieldName.toLowerCase() == 'pdpm category'">
               <mat-label>{{ field.fieldName }}</mat-label>
              <mat-select (selectionChange)="selectStage($event.value)">
               <mat-option *ngFor="let stat of getPDPMStagesList" [value]="stat.processStageID">
                 {{ stat.processStageName }}
                </mat-option>
              </mat-select>
            </mat-form-field>

             <mat-form-field *ngIf="field.fieldName == 'Process Stage'">
               <mat-label>{{ field.fieldName }}</mat-label>
              <mat-select [required]="field.isRequired" formControlName="{{ field.fieldName }}" [disabled]="field.rolePermission==1">
               <mat-option *ngFor="let stat of ProcessStageListForDropDown" [value]="stat.processStageID">
                 {{ stat.processStageName }}
                </mat-option>
              </mat-select>
            </mat-form-field>

           

         <mat-form-field *ngIf="field.fieldName != 'Type' && field.fieldName != 'Process Stage' && field.fieldName.toLowerCase() != 'pdpm category'">
              <mat-label>{{ field.fieldName }}</mat-label>
              <mat-select [required]="field.isRequired" formControlName="{{ field.fieldName }}" [disabled]="field.rolePermission==1"
                [ngModel]="getddlSelectedVal(field.fieldName,field.fieldValue)">
                <mat-option *ngFor="let drp of getdropdownlist(field.fieldName)" [value]="drp">
                  {{ drp }}
                </mat-option>
              </mat-select>
            </mat-form-field>

          </ng-container>

          <ng-container *ngSwitchCase="'MultiSelect'">

            <mat-form-field class="example-chip-list" *ngIf="field.fieldName == 'Tags'">
              <mat-label>{{ field.fieldName }}</mat-label>
              <mat-chip-list [required]="field.isRequired" #chipList aria-label="Fruit selection">
                <mat-chip *ngFor="let fruit of tags" [selectable]="selectable" [removable]="removable"
                  (removed)="remove(fruit)">
                  {{fruit}}
                  <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                </mat-chip>
                <input placeholder="Add Tags" #fruitInput [formControl]="fruitCtrl" [matAutocomplete]="auto"
                  [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  (matChipInputTokenEnd)="add($event)">
              </mat-chip-list>
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                <mat-option *ngFor="let fruit of filteredFruits | async" [value]="fruit">
                  {{fruit}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>


            <mat-form-field *ngIf="field.fieldName != 'Tags'">
              <mat-label>{{ field.fieldName }}</mat-label>
              <mat-select [required]="field.isRequired" multiple formControlName="{{ field.fieldName }}" [disabled]="field.rolePermission==1">
                <mat-option *ngFor="let muldrp of getMuldropdownlist(field.fieldName)" [value]="muldrp">
                  {{ muldrp }}
                </mat-option>
              </mat-select>
            </mat-form-field>

          </ng-container>
         

          <ng-container *ngSwitchCase="'Checkbox'">
            <mat-label>{{ field.fieldName }}</mat-label>
            <ul class="check">
              <li *ngFor="let chk of getCheckBoxlist(field.fieldName)">
                <mat-checkbox [disabled]="field.rolePermission==1" color="primary" (change)="OnChange($event, chk, field.fieldID)">
                  {{ chk }}
                </mat-checkbox>
              </li>
            </ul>
          </ng-container>
        </div>
      </ng-container>
    </form>
  </div>

  <div class="actionBtn">
    <button mat-flat-button class="cancel" (click)="closeListing(close)">
      Cancel
    </button>
    <button mat-flat-button class="calltoaction"
     [disabled]="!myFormGroup.dirty" type="submit"
      (click)="onSubmit(myFormGroup.value, myFormGroup)" color="primary">
      Save
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
      </mat-spinner></mat-icon>
    </button>
    <!-- <button mat-flat-button class="calltoaction" [disabled]="myFormGroup.invalid || !myFormGroup.dirty" type="submit"
      (click)="onSubmit(myFormGroup.value, myFormGroup)" color="primary">
      Save
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
      </mat-spinner></mat-icon>
    </button> -->
  </div>

</mat-card>


<div class="overlay" (click)="closeListing(close)"></div>
